import {
    StaticResource,
    IFrameResource,
    HTMLResource,
} from '@lib/iab/iab-vast-model';

import createHTMLResource from './html-resource';
import createIFrameResource from './iframe-resource';
import createStaticResource from './static-resource';

interface UnmarshalerNode {
    _value: unknown;
    [key: string]: unknown;
}

const createResource = (
    $parent: UnmarshalerNode
): StaticResource | IFrameResource | HTMLResource | null =>
    $parent.staticResource != null
        ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
          createStaticResource($parent.staticResource as any)
        : $parent.iFrameResource != null
          ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
            createIFrameResource($parent.iFrameResource as any)
          : $parent.htmlResource != null
            ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
              createHTMLResource($parent.htmlResource as any)
            : null;

export default createResource;
